import { Component, OnInit } from '@angular/core';
import { AssetsManagementService } from '../../services/assets-management.service';
import { MasterDataService } from '../../services/master-data.service';
import * as moment from 'moment';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-assets-physical-verification-report',
  templateUrl: './assets-physical-verification-report.component.html',
  styleUrls: ['./assets-physical-verification-report.component.css']
})
export class AssetsPhysicalVerificationReportComponent implements OnInit {
  selectType;
  selectBranch;
  reportList = [];
  branchList;
  selectDate;
  currentDate;
  formatCurrentDate;
  userRole;
  accessResponse: any;
  constructor(private assetsManagementService: AssetsManagementService, private masterDataService: MasterDataService, private commonMessageService: CommonMessageService,
    private branchFilterService: BranchFilterService
  ) {
    const current = new Date();
    this.currentDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
  }

  ngOnInit(): void {
    this.selectType = 'Software';
    this.selectBranch = "null";
    // this.masterDataService.getBranch().subscribe((res) => {
    //   console.log('branchlist', res);
    //   this.branchList = res;
    // });
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });

    var currentDate1 = new Date(this.currentDate.year + '-' + this.currentDate.month + '-' + this.currentDate.day);
    this.formatCurrentDate = moment(currentDate1).format("YYYY-MM-DD");
  }

  showExcelButton: boolean;
  changeSelectedDate2;
  onViewReport() {
    console.log('selectType', this.selectType);
    console.log('selectType', this.selectBranch);
    console.log('selectType', this.selectDate);
    if (this.selectBranch == "null" || this.selectBranch == undefined || this.selectBranch == '' ||
      this.selectDate == undefined) {
      this.commonMessageService.swalAlertWithoutIcon('', "Please select all fields.");
    } else {
      if (this.selectDate) {
        var changeSelectedDate1 = new Date(this.selectDate.year + '-' + this.selectDate.month + '-' + this.selectDate.day);
        this.changeSelectedDate2 = moment(changeSelectedDate1).format("YYYY-MM-DD");
      }
      this.assetsManagementService.physicalVerificationReport(this.selectType, this.selectBranch.id, this.changeSelectedDate2).subscribe((resp: any) => {
        console.log('physical code', resp);
        this.reportList = resp;
        if (this.reportList.length > 0) {
          this.showExcelButton = true;
        } else {
          this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found');
          this.showExcelButton = false;
        }
      });
    }
  }

  onExportToExcelReport() {
    this.assetsManagementService.physicalVerificationReportExportToExcel(this.selectType, this.selectBranch.id, this.changeSelectedDate2).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "PhysicalVerificationReport.xlsx";
      link.click();
    });
  }
  getEmployeeName(data) {
    if (data.asset.release == true) {
      return 'NA';
    } else {
      if (data.user != null) {
        return data.user.firstName + ' ' + data.user.lastName;
      } else {
        return 'NA';
      }
    }
  }
  getSoftwareStatus(data) {
    var status;
    if (data.software.block == true && data.software.release == false && data.software.retired == false) {
      status = 'Blocked';
    }
    else if (data.software.block == false && data.software.release == true && data.software.retired == false) {
      status = 'Discarded';
    }
    else if (data.software.block == false && data.software.release == false && data.software.retired == true) {
      if (data.user != null) {
        if (data.user.id == 54) {
          status = 'Retired';
        } else {
          status = 'Retired';
        }
      } else {
        status = 'Retired';
      }
    } else if (data.hardware != null) {
      status = 'Assigned';
    } else {
      status = 'Instock'
    }
    return status;
  }

  getHardwareStatus(data) {
    var status;
    if (data.asset.block == true && data.asset.release == false && data.asset.retired == false) {
      status = 'Blocked';
    }
    else if (data.asset.dateOfSale <= this.changeSelectedDate2) {
      status = 'Discarded';
    }
    else if (data.asset.dateOfRetirementOfAsset <= this.changeSelectedDate2) {
      if (data.user != null) {
        if (data.user.id == 54) {
          status = 'Retired';
        } else {
          status = 'Retired';
        }
      } else {
        status = 'Retired';
      }
    } else if (data.user != null && data.user.id != 54 && data.user.id != 0) {
      status = 'Assigned';
    } else {
      status = 'Instock';
    }
    return status;
  }


  selectTypeClick() {
    this.reportList = [];
    this.showExcelButton = false;
  }
}
